import React from "react";
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import axios from 'axios';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import { whereBallsMove, getHeader } from "../../helper";
import envelope from "../../images/envelope.svg";

class Invite extends React.Component {
    state = {
        loading: false,
        acceptLoading: false,
        declineLoading: false,
        inviteData: null,
        companyData: null,
        acceptSuccess: false,
    }

    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(5);
    }

    onAccept() {
        this.setState({
            acceptLoading: true,
        });

        let formData = new FormData();
        formData.append('invite_token', this.code)

        axios.post(
            `${window.siteUrl}/api/v1/invite_to_company/accept/`,
            formData,
            {
                headers: getHeader()
            }
        )
        .then(response => {
            this.setState({
                acceptSuccess: true,
                acceptLoading: false,
            });

            Alert.success('Изменения сохранены.', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });
        })
        .catch(error => {
            if(error.response.data){
                Alert.success(error.response.data, {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }
        });
    }

    onDecline() {
        let formData = new FormData();
        formData.append('invite_token', this.code)

        axios.post(
            `${window.siteUrl}/api/v1/invite_to_company/decline/`,
            formData,
            {
                headers: getHeader()
            }
        )
        .then(response => {
            this.redirectToMain();
        })
        .catch(error => {
            if(error.response.data){
                Alert.success(error.response.data, {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }
        });
    }

    getCompanyById(id) {
        if(!id) this.redirectToMain();

        axios.get(`${window.siteUrl}/api/v1/company/${id}/`, {
            params: {},
            headers: getHeader()
        })
        .then(response => {
            this.setState({
                loading: false,
                companyData: response.data
            });
        })
        .catch(error => {
            this.redirectToMain();
        });
    }

    componentWillMount() {
        const {match:{params}, session} = this.props;
        this.code = localStorage.getItem('invite_code');

        if(!this.code) this.redirectToMain();

        this.setState({
            loading: true,
        });

        axios.get(`${window.siteUrl}/api/v1/invite_to_company/view/?invite_token=${this.code}`, {
            params: {},
            headers: getHeader()
        })
        .then(response => {
            const {data} = response;

            if(data.email === session.currentUser.username) {
                this.getCompanyById(data.company_id)

                this.setState({
                    inviteData: data
                });
            }
            else{
                this.redirectToMain();
            }
        })
        .catch(error => {
            this.redirectToMain();
        });
    }

    redirectToMain() {
        localStorage.removeItem('invite_code');

        this.props.history.replace('/', 'state');
    }

    render() {

        if(this.state.loading) return <div></div>

        const {acceptLoading, declineLoading, acceptSuccess, companyData} = this.state;
        const {currentUser} = this.props.session;

        return (
            <div className="vertical-scrolling page firstSection sectionHome" id="sectionHome" data-main-nav-id="homeNavLink">
                <div className="container content">
    
                    <Alert stack={{limit: 1}} />

                    <div className="left-content left-content-width error-block">
                        {/* <h1>Fix<span className="text_gradient_violet">Fact</span></h1>
                        <ul className="main-advantages">
                            <li>Ошибка 404</li>
                            <li>Страница не найдена</li>
                        </ul>
                        <Link className="" to="/">
                            <button className="error-btn">
                                На главную страницу
                            </button>
                        </Link> */}
                    </div>

                    <div className="right-content right-content-out right-content-width">
                        <div className="screen-outer-block-wrap native-scroll">
                            <div className="rounded-white-block screen-bottom-block">
                                <div
                                    className="white-block-top header-tabs tab-nav"
                                    style={{padding: '30px', flexDirection:'column'}}>

                                    <div className="invite-image-sprite">
                                        <img src={envelope} className="invite-image"/>
                                    </div>

                                    <h3 className="invite-title">
                                        {
                                            acceptSuccess
                                            ? `Поздравляем! Теперь вы являетесь сотрудником компании ${companyData && companyData.title}`
                                            : `${currentUser.first_name} ${currentUser.last_name}, вас приглашают присоединиться в компанию ${companyData && companyData.title}`
                                        }
                                    </h3>

                                    {
                                        acceptSuccess
                                        ?
                                        <div style={{flexDirection:'row', display:'flex'}}>
                                            <Link
                                                to={`/account/entity/${companyData && companyData.id}`}
                                                className="button-action big-button violet-button-gradient"
                                                >
                                                <button
                                                    style={{paddingLeft: '20px', paddingRight:'20px'}}
                                                    >
                                                    Перейти на страницу компании
                                                </button>
                                            </Link>
                                        </div>
                                        :
                                        <div style={{flexDirection:'row', display:'flex'}}>
                                            <div
                                                className="big-button button-action empty-button"
                                                style={{marginRight:'10px'}}
                                                >
                                                <button
                                                    onClick={() => this.onDecline()}
                                                    style={{paddingLeft: '20px', paddingRight:'20px'}}
                                                    className={declineLoading ? 'disabled' : ''}
                                                    >Отвергнуть</button>
                                            </div>
                                            <div
                                                className="button-action big-button violet-button-gradient"
                                                style={{marginLeft:'10px'}}
                                                >
                                                <button
                                                    onClick={() => this.onAccept()}
                                                    style={{paddingLeft: '20px', paddingRight:'20px'}}
                                                    className={acceptLoading ? 'disabled' : ''}
                                                    >
                                                    Принять
                                                </button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
	state => ({
		session: state.session
	})
)(Invite);


// WEBPACK FOOTER //
// ./src/components/Invite/index.js